/**
 * @param token
 */
function setToken(token) {
  if (typeof token === 'string' && token.length > 0) {
    localStorage.setItem('sb-token', token);
  }
}

/**
 * @returns {string | null}
 */
function getToken() {
  return localStorage.getItem('sb-token') || null;
}

/**
 * @returns null
 */
function removeToken() {
  localStorage.removeItem('sb-token');
}

/**
 * @param type
 */
function setUserType(type) {
  localStorage.setItem('sb-ut', type);
}

/**
 * @returns {string | null}
 */
function getUserType() {
  return localStorage.getItem('sb-ut') || null;
}

/**
 * @returns void
 */
function removeUserType() {
  return localStorage.removeItem('sb-ut');
}

/**
 * @param {*} token
 */
function setPasswordWasReset(email) {
  if (typeof email === 'string' && email.length > 0) {
    localStorage.setItem('sb-pw-reset', email);
  }
}

/**
 * @returns {string | null}
 */
function PasswordWasReset() {
  return localStorage.getItem('sb-pw-reset') || null;
}

/**
 *
 */
function removePasswordWasReset() {
  localStorage.removeItem('sb-pw-reset');
}

/**
 */
function removeWhitelabel() {
  localStorage.removeItem('sb-control-whitelabel');
}

/**
 */
function saveWhitelabel(whitelabel) {
  localStorage.setItem('sb-control-whitelabel', JSON.stringify(whitelabel));
}

/**
 */
function getWhitelabel() {
  const data = localStorage.getItem('sb-control-whitelabel');
  return data ? JSON.parse(data) : null;
}

/**
 */
function saveLsaOptions(options) {
  localStorage.setItem('sb-lsa-options', JSON.stringify(options));
}

/**
 */
function getLsaOptions() {
  const data = localStorage.getItem('sb-lsa-options');
  return data ? JSON.parse(data) : null;
}
export { setToken, getToken, removeToken, setUserType, getUserType, removeUserType, setPasswordWasReset, PasswordWasReset, removePasswordWasReset, removeWhitelabel, saveWhitelabel, getWhitelabel, saveLsaOptions, getLsaOptions };